export const products = [
  {
    id: "complete-session",
    name: "Book a Complete Session",
    summary: "A comprehensive 30-minute deep dive into your crypto portfolio.",
    description:
      "Our most popular service. We sit down for 30 minutes to audit your current holdings, analyze risk exposure, and build a personalized asset allocation plan. You'll leave with a clear roadmap for entry/exit points and a sustainable strategy to grow your wealth.",
    priceIndian: 150,
    priceInternational: 10,
    image: "complete.jpg",
  },
  {
    id: "mini-session",
    name: "Mini Consultation Call", // Fixed: Was a duplicate of the first title
    summary: "Quick 15-minute power call for urgent, targeted questions.",
    description:
      "Need a fast second opinion? This focused 15-minute consultation is designed for rapid-fire problem solving. Whether it's a specific trade, a technical hurdle, or a quick tax query, we get straight to the point with actionable answers.",
    priceIndian: 100,
    priceInternational: 7,
    image: "mini.jpg",
  },
  {
    id: "urgent-contacts",
    name: "Urgent Priority Support",
    summary: "Immediate, high-priority expert guidance for critical situations.",
    description:
      "When every minute counts. This premium service puts you at the front of the line for expert guidance on time-sensitive issues like tax compliance deadlines, security concerns, or major market shifts. We help you navigate complex crises with professional clarity.",
    priceIndian: 300,
    priceInternational: 15,
    image: "priority.jpg",
  },
];